interface LineSetupIconProps {
    width?: number | string
    height?: number | string
    className?: string
    color?: string
    strokeWidth?: number | string
}

export default function LineSetupIcon({
    width = 24,
    height = 24,
    className,
    color = "currentColor",
    strokeWidth = 20,
}: LineSetupIconProps) {
    return (
        <svg
            id="Layer_3"
            data-name="Layer 3"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 654.01258 684.87492"
            width={width}
            height={height}
            className={className}
        >
            <path
                d="M305.44936,641.59507c4.65798,4.55036,49.8912-18.82516,57.45758-22.92151,52.37375-28.3545,98.60122-66.57616,143.59807-105.1124,6.07905-2.56825,13.82427,4.53632,12.3899,10.75832-1.15229,4.99843-33.86949,32.41084-40.31747,37.67891-35.34187,28.87468-82.45933,62.09101-123.33901,82.15005-30.14915,14.79374-71.36863,34.86836-67.99802-18.28139.61545-9.70476,8.80744-36.89897,1.5934-43.06436-66.48472-19.11613-133.04507-36.75759-188.70258-79.75936C-11.10148,417.10337-16.50037,267.12945,80.86274,167.59804c4.2575-4.35231,28.44351-26.17166,32.26804-27.41017,8.58363-2.77967,16.34558,4.21011,12.4926,12.50538-1.67204,3.59982-28.0216,24.3294-33.99293,30.644C-3.87324,284.33126,14.63942,427.57696,130.58277,502.42085c52.1216,33.6456,99.77322,40.2078,155.83606,59.59602,41.97106,14.51486,16.35479,46.90377,19.03053,79.5782Z"
                fill="none"
                stroke={color}
                strokeMiterlimit="10"
                strokeWidth={Number(strokeWidth) * 1.2}
            />
            <path
                d="M296.31158,61.99142c131.81828-9.62944,287.8293,41.7685,333.48814,177.59537,29.42396,87.531,3.33556,159.25364-53.12961,227.05089-4.26498,5.12092-22.18589,26.18489-26.50196,28.19184-7.53047,3.50164-15.12172-3.35138-12.88139-11.15289,37.41635-43.45794,80.3284-95.0014,85.61119-154.75698,18.04319-204.09338-236.52412-287.16829-398.36333-232.64633-10.0125,3.37311-25.38091,12.08813-34.28373,13.82165-10.2142,1.98887-15.00426-9.61655-7.85786-16.19811,6.11882-5.6352,42.72149-17.5484,52.58354-20.32498,19.60702-5.5202,40.98362-10.09377,61.33501-11.58046Z"
                fill="none"
                stroke={color}
                strokeMiterlimit="10"
                strokeWidth={Number(strokeWidth) * 1.2}
            />
            <path
                d="M310.42048,298.55418v93.6301c0,9.88214-17.59276,13.83369-19.78199-.10413,3.17936-39.16664-4.60346-85.98297-.14185-124.22138,1.19513-10.24289,9.3265-15.0102,17.51415-7.49504l70.35364,99.50574v-96.94444c0-6.19312,16.11348-10.56439,18.18879.03898l-.82715,133.32573c-2.71126,3.97876-6.19325,6.19777-11.20198,4.7197-8.80433-2.59814-60.85235-91.5608-74.10362-102.45526Z"
                fill="none"
                stroke={color}
                strokeMiterlimit="10"
                strokeWidth={Number(strokeWidth) * 1.2}
            />
            <path
                d="M454.59426,275.3538v44.74359h48.88651c6.64526,0,6.26065,18.22887-1.65717,18.22887h-47.22934v44.74359h48.88651c4.19268,0,10.28253,15.95665-3.4256,18.11739-8.17571,1.2887-48.45071,1.51189-56.18966.06862-4.1421-.77248-7.58405-4.79667-7.58607-8.98563l.89071-131.85478c1.59505-3.22882,8.18884-4.56082,11.62471-4.94699,10.02807-1.12708,39.82378-1.30962,49.3188.39485,17.16756,3.08179,9.20825,19.49049,2.05277,19.49049h-45.57217Z"
                fill="none"
                stroke={color}
                strokeMiterlimit="10"
                strokeWidth={Number(strokeWidth) * 1.2}
            />
            <path
                d="M151.33218,383.06984h53.85802c4.24852,0,11.27183,14.95138-2.01211,17.8739-9.16229,2.01574-50.44335,1.49021-60.98816.35509-8.89214-.95722-9.84575-5.57645-10.83212-14.00209,3.72508-37.10229-4.7539-83.25641.23893-119.24958,2.48891-17.94247,19.73544-10.52905,19.73544-3.46496v118.48764Z"
                fill="none"
                stroke={color}
                strokeMiterlimit="10"
                strokeWidth={Number(strokeWidth) * 1.2}
            />
            <path
                d="M251.99557,399.1941c-6.23599,5.62068-16.8121-.40169-16.17858-8.63625,3.35003-38.79562-4.36834-84.78891-.00695-122.69908,1.72685-15.01018,17.99346-15.83037,19.92313,1.69564,4.09298,37.17404-3.08656,81.40352.04539,119.35255-.27968,2.52306-2.11039,8.77958-3.78299,10.28715Z"
                fill="none"
                stroke={color}
                strokeMiterlimit="10"
                strokeWidth={Number(strokeWidth) * 1.2}
            />
            <path
                d="M152.86708,112.32122c10.99917-2.17662,15.84745,9.41625,6.97324,17.00661-21.01239,17.97249-30.92103-12.2676-6.97324-17.00661Z"
                fill="none"
                stroke={color}
                strokeMiterlimit="10"
                strokeWidth={strokeWidth}
            />
        </svg>
    )
}
